import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconZoomIn = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3333 7C8.9401 7 7 8.9401 7 11.3333C7 13.7266 8.9401 15.6667 11.3333 15.6667C13.7266 15.6667 15.6667 13.7266 15.6667 11.3333C15.6667 8.9401 13.7266 7 11.3333 7ZM5 11.3333C5 7.83553 7.83553 5 11.3333 5C14.8311 5 17.6667 7.83553 17.6667 11.3333C17.6667 12.7214 17.2202 14.0051 16.4629 15.0487L18.7071 17.2929L17.2929 18.7071L15.0487 16.4629C14.0051 17.2202 12.7214 17.6667 11.3333 17.6667C7.83553 17.6667 5 14.8311 5 11.3333ZM10.3333 12.3333V13.3333H12.3333V12.3333H13.3333V10.3333H12.3333V9.33333H10.3333V10.3333H9.33333V12.3333H10.3333Z"
        />
      </svg>
    );
  }
);
